import axios from 'axios'

async function postApi(path, data, headers) {
    const formData = new FormData();
  for (let key in data){
    formData.append(key, data[key]);
  } 
  return await axios
        .post(path, data, {
            headers,
            withCredentials: true
        })
        .then((res) => res.data)
        .catch((err) => {
            if (err.response) {
                console.log(err.response.data)
                console.log(err.response.status)
                console.log(err.response.headers)
            } else if (err.request) {
                console.log(err.request)
            } else {
                console.log('Error', err.message)
            }
        })
}

async function putApi(path, data, headers) {
    return await axios
        .put(path, data, {
            headers,
            withCredentials: true
        })
        .then((res) => res.data)
        .catch((err) => {
            if (err.response) {
                console.log(err.response.data)
                console.log(err.response.status)
                console.log(err.response.headers)
            } else if (err.request) {
                console.log(err.request)
            } else {
                console.log('Error', err.message)
            }
        })
}

async function patchApi(path, data, headers) {
    return await axios
        .patch(
            path,
            {},
            {
                headers,
                withCredentials: true,
                params: data,
                paramsSerializer: {
                    indexes: null
                }
            }
        )
        .then((res) => res.data)
        .catch((err) => {
            if (err.response) {
                console.log(err.response.data)
                console.log(err.response.status)
                console.log(err.response.headers)
            } else if (err.request) {
                console.log(err.request)
            } else {
                console.log('Error', err.message)
            }
        })
}

async function getApi(path, data, headers) {
    return await axios
        .get(path, {
            headers,
            withCredentials: true,
            params: data,
            paramsSerializer: {
                indexes: null
            }
        })
        .then((res) => res.data)
        .catch((err) => {
            if (err.response) {
                console.log(err.response.data)
                console.log(err.response.status)
                console.log(err.response.headers)
            } else if (err.request) {
                console.log(err.request)
            } else {
                console.log('Error', err.message)
            }
        })
}

async function deleteApi(path, data, headers) {
    return await axios
        .delete(path, {
            headers,
            withCredentials: true,
            params: data,
            paramsSerializer: {
                indexes: null
            }
        })
        .then((res) => res.data)
        .catch((err) => {
            if (err.response) {
                console.log(err.response.data)
                console.log(err.response.status)
                console.log(err.response.headers)
            } else if (err.request) {
                console.log(err.request)
            } else {
                console.log('Error', err.message)
            }
        })
}

export async function api(method, path, data, headers = {}) {
    let startUrl = ''
    if (process.env.VUE_APP_SERVER_URL) {
        startUrl = process.env.VUE_APP_SERVER_URL
    }
    if (!startUrl) {
        startUrl = window.location.origin + '/api'
    }
    const methodToApi = {
        POST: postApi,
        GET: getApi,
        PATCH: patchApi,
        DELETE: deleteApi,
        PUT: putApi
    }

    return await methodToApi[method](startUrl + path, data, headers)
}
